export default {
  text_placeholder: 'Enter Message...',
  attach: {
    attach_image: {
      btn_select: 'Attach image',
      title: 'Select an image',
      dropzone: {
        description: '<p>You can upload an image that meets the requirements:</p><p>1600x1200px maximum image size, up to 2MB.</p><p>Or choose from a gallery of previously uploaded images.</p>',
      },
    },
    attach_video: {
      btn_select: 'Attach video',
      title: 'Choose a video',
      dropzone: {
        description: '<p>You can upload a video that meets the requirements:</p><p>Video file size up to 200MB, format 3gp, m4v, mov, mp4.</p><p>Or choose from previously uploaded videos.</p>',
      },
    },
    attach_document: {
      btn_select: 'Attach document',
      title: 'Choose a document',
      dropzone: {
        description: '<p>You can upload a video that meets the requirements:</p><p>Video file size up to 200MB, format 3gp, m4v, mov, mp4.</p><p>Or choose from previously uploaded videos.</p>',
      },
      upload_description: {
        viber: 'You can upload a file that meets the requirements:<br>' +
          'Maximum file size 200Mb.<br>' +
          'File extension: .doc, .docx, .rtf, .dot, .dotx, .odt ,odf, .fodt, .txt, .info, .pdf, .xps, .pdax, .eps, .xls, .xlsx, .ods, .fods, .csv, .xlsm, .xltx',
        whatsapp: 'You can upload a file that meets the requirements:<br>' +
          'Maximum file size 100Mb.',
      },
    },
    modal: {
      title: 'Attach file',
      description: 'Select file or upload one to attach to the message',
      btn_upload: 'Upload',
      empty_description: 'There are no images in account gallery.<br>Upload image that meets the channel requirements.',
      empty_video_description: 'There are no video in account gallery.<br>Upload video that meets the channel requirements.',
      empty_document_description: 'There are no documents in account gallery.<br>Upload document that meets the channel requirements.',
    },
  },
  fast_answers: {
    more: 'More',
  },
  reassign: {
    start_chatting: 'Start chatting',
    assign_to_user: 'Assign to user ...',
  },
};
